import React from "react";
import ReactDOM from "react-dom/client";

import { App } from "@/app/App";
import { initDevHarness } from "@/dev-harness/telemetry";
import { createRuntimeBus } from "@/runtime/bus";

import "./styles.css";

const bus = createRuntimeBus();
void initDevHarness(bus);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App bus={bus} />
  </React.StrictMode>,
);
